import axios from 'axios'
import { getUserData } from '../auth/utils'

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 60 * 4 * 1000
})

api.interceptors.request.use(
  async config => {
    const userData = getUserData()

    if (userData && userData.accessToken) {
      config.headers.authorization = `Bearer ${userData.accessToken}`
    }

    return config
  },
  error => Promise.reject(error)
)

export default api
